import { interceptors } from './http.interceptor'
import httpRequestFactory from './httpRequestFactory'

export default httpRequestFactory({
    errorHandler: interceptors.error,
    intercepterRequest: interceptors.request,
    intercepterResponse: interceptors.response
})
